module.exports = __webpack_public_path__ + "static/img/6.70859d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/eng/6.png
// module id = 5cgf
// module chunks = 0